module.exports = __webpack_public_path__ + "img/swingVariabilityText11.293bb679.png";